import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Body2 from '@joinforma/ui/components/Body2';
import Title2 from '@joinforma/ui/components/Title2';

import { ReactComponent as AlertCircleIcon } from '@joinforma/ui/assets/icons/exclamation-mark.svg';

import { SettingsRoutes } from 'utils/routeGenerator';
import { CONNECTED_ACCOUNT_STATUSES } from 'constants/stripe';
import { SCREEN_WIDTHS } from '@joinforma/ui/constants/breakpoints';

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.background.secondary};
`;

const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  padding: 12px;

  @media (min-width: ${SCREEN_WIDTHS.MOBILE_PORTRAIT}) {
    align-items: center;
    flex-direction: row;
  }

  @media (min-width: ${SCREEN_WIDTHS.TABLET_PORTRAIT}) {
    align-items: center;
    flex-direction: row;
  }
`;

const InfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${SCREEN_WIDTHS.MOBILE_PORTRAIT}) {
    display: block;
    margin-left: 14px;
  }
`;
const InfoText = styled(Title2)``;

const BankLink = styled(Link)`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.text.link};
`;

const BankLinkText = styled(Body2)`
  display: inline;
  color: ${({ theme }) => theme.colors.text.link};
`;

const SetupDirectDepositBanner = ({
  connected_account_status,
}: {
  connected_account_status?: string;
}) => {
  const getBannerText = () => {
    switch (connected_account_status) {
      case CONNECTED_ACCOUNT_STATUSES.PENDING_VERIFICATION:
        return 'We need to verify your linked bank account to complete your direct deposit set up.';
      case CONNECTED_ACCOUNT_STATUSES.PENDING:
        return 'We need to relink and confirm your bank account to set up direct deposit for your new benefits accounts';
    }

    return `Enroll in direct deposit to get your claims reimbursed in 2-3 business days.`;
  };

  const banner_link_text =
    connected_account_status === CONNECTED_ACCOUNT_STATUSES.PENDING_VERIFICATION
      ? 'Verify bank account'
      : 'Link bank account';
  return (
    <Card>
      <Container>
        <AlertCircleIcon />
        <InfoTextContainer>
          <InfoText>{getBannerText()}</InfoText>
          <BankLink to={SettingsRoutes.bankAccounts()}>
            <BankLinkText>{banner_link_text}</BankLinkText>
          </BankLink>
        </InfoTextContainer>
      </Container>
    </Card>
  );
};

export default SetupDirectDepositBanner;
